<mat-card appearance="outlined" class="w-full" [testId]="testIds.WORKSHOP_EVENT">
  <mat-card-content>
    <div class="flex flex-row items-center">
      <p class="text-lg flex-grow" [testId]="testIds.EVENT_TYPE_FIELD">
        {{ event.type | workshopJobEventLabel }}
      </p>
      <div class="flex flex-row items-center space-x-2">
        <p class="text-gray-600">
          {{ event.created_at | amDateFormat : 'DD/MM/YY HH:mm' }}
        </p>
        <button mat-icon-button (click)="onEditClick()" testId="edit_event_button" *ngIf="event.type !== 'booked_in'"
          class="text-gray-500 hover:text-blue-600" title="Edit event">
          <mat-icon>edit</mat-icon>
        </button>
      </div>
    </div>
    <ng-container [ngSwitch]="event.type">
      <!--      Booked In-->
      <p *ngSwitchCase="'booked_in'" [testId]="testIds.BOOKED_IN_BY">
        Booked in by {{ event.created_by | userIdToName | async }}
      </p>

      <!--      Assessment -->
      <ng-container *ngSwitchCase="'assessment'">
        <app-key-value-pair name="Summary" [key]="testIds.ASSESSMENT_SUMMARY" [value]="event.details?.assessment"
          [multiline]="true"></app-key-value-pair>
        <app-key-value-pair [key]="testIds.ESTIMATED_LABOUR_HOURS" name="Estimated labour hours"
          notSetMessage="Not provided" [value]="event.details?.estimated_labour_hours"></app-key-value-pair>
        <app-key-value-pair [key]="testIds.ESTIMATED_PARTS_COST_KP" name="Estimated parts cost"
          notSetMessage="Not provided"
          [value]="event.details?.estimated_parts_cost | hlCurrency | async"></app-key-value-pair>
        <app-key-value-pair name="Estimated total cost" [key]="testIds.ESTIMATED_TOTAL_COST_KP"
          [value]="event.details?.estimated_total_cost | hlCurrency | async"></app-key-value-pair>
        <p class="text-sm" [testId]="testIds.ASSESSED_BY">
          Assessment added by {{ event.created_by | userIdToName | async }}
        </p>
      </ng-container>

      <!--      Quotation -->
      <ng-container *ngSwitchCase="'quotation'">
        <app-key-value-pair [key]="testIds.WORK_REQUIRED_KP" name="Work required" [value]="event.details?.work_required"
          [multiline]="true"></app-key-value-pair>
        <app-key-value-pair name="Estimated total cost" notSetMessage="Not provided"
          [key]="testIds.ESTIMATED_TOTAL_COST_KP"
          [value]="event.details?.estimated_total_cost | hlCurrency | async"></app-key-value-pair>
        <app-key-value-pair *ngIf="event.details?.send_email" [key]="testIds.EMAIL_SENT_TO_KP" name="Email sent to"
          notSetMessage="Not provided" [value]="event.details?.email_address"></app-key-value-pair>
        <p class="text-sm">
          Quotation added by {{ event.created_by | userIdToName | async }}
        </p>
      </ng-container>

      <!--      Quotation Approved -->
      <ng-container *ngSwitchCase="'quote_approved'">
        <app-key-value-pair name="Notes" [key]="testIds.QUOTE_APPROVED_NOTES_KP" *ngIf="event.details?.notes"
          [value]="event.details?.notes" [multiline]="true"></app-key-value-pair>
        <p *ngIf="
            event.created_by && !event.details.via_email;
            else viaEmailLink
          " class="text-sm" [testId]="testIds.QUOTATION_ACCEPTED_BY">
          Quotation marked as accepted by
          {{ event.created_by | userIdToName | async }}
        </p>
        <ng-template #viaEmailLink>
          <p [testId]="testIds.QUOTATION_ACCPTED_VIA_EMAIL">
            Quotation accepted by customer clicking accept button in quotation
            email
          </p>
        </ng-template>
      </ng-container>

      <!--      Waiting for parts -->
      <ng-container *ngSwitchCase="'waiting_for_parts'">
        <app-key-value-pair [key]="testIds.WAITING_FOR_PARTS_NOTES_KP" name="Notes" [value]="event.details?.notes"
          [multiline]="true"></app-key-value-pair>
        <p class="text-sm" [testId]="testIds.MARKED_WAITING_PARTS_BY">
          Marked as waiting for parts by
          {{ event.created_by | userIdToName | async }}
        </p>
      </ng-container>

      <!--      Repair started -->
      <ng-container *ngSwitchCase="'repair_started'">
        <app-key-value-pair name="Notes" *ngIf="event.details?.notes" [value]="event.details?.notes"
          [multiline]="true"></app-key-value-pair>
        <p class="text-sm">
          Marked as repair started by
          {{ event.created_by | userIdToName | async }}
        </p>
      </ng-container>

      <!--  Repair completed -->
      <ng-container *ngSwitchCase="'completed'">
        <app-key-value-pair [key]="testIds.LABOUR_HOURS_KP" name="Labour hours" notSetMessage="Not provided"
          [value]="event.details?.labour_hours"></app-key-value-pair>
        <app-key-value-pair [key]="testIds.LABOUR_COST_KP" name="Labour cost" notSetMessage="Not provided"
          [value]="event.details?.labour_cost | hlCurrency | async"></app-key-value-pair>
        <app-key-value-pair [key]="testIds.COMPLETED_NOTES_KP" name="Notes" [multiline]="true"
          notSetMessage="Not provided" [value]="event.details?.notes"></app-key-value-pair>
        <p class="text-sm" [testId]="testIds.COMPLETED_BY">
          Updated to repair completed by
          {{ event.created_by | userIdToName | async }}
        </p>
      </ng-container>

      <!--  Repair cancelled -->
      <ng-container *ngSwitchCase="'cancelled'">
        <app-key-value-pair name="Labour hours" [key]="testIds.LABOUR_HOURS_KP" notSetMessage="Not provided"
          [value]="event.details?.labour_hours"></app-key-value-pair>
        <app-key-value-pair name="Labour cost" [key]="testIds.LABOUR_COST_KP" notSetMessage="Not provided"
          [value]="event.details?.labour_cost | hlCurrency | async"></app-key-value-pair>
        <p class="text-sm" [testId]="testIds.CANCELLED_BY">
          Marked as repair cancelled by
          {{ event.created_by | userIdToName | async }}
        </p>
      </ng-container>
    </ng-container>
  </mat-card-content>
</mat-card>